import { createRoute } from "@tanstack/react-router";
import { Logs } from "lucide-react";
import { Suspense } from "react";
import { useDocumentTitle } from "usehooks-ts";
import { z } from "zod";
import ContentFrame from "@/components/ContentFrame";
import SidePanel from "@/components/SidePanel";
import SimpleTaskListHeader from "@/components/SimpleTaskListHeader";
import TaskListRouteSkeleton from "@/components/TaskListRouteSkeleton";
import { TaskQueryParamsProvider } from "@/components/task-table/TaskQueryParamsContext";
import TasksTable from "@/components/task-table/TasksTable";
import { useRouteTaskQueryParams } from "@/hooks/task-query-params/useRouteTaskQueryParams";
import { appRoute } from "./appRoute";

const allTasksSearchSchema = z.object({
    task: z.coerce.number().optional(),
    filter: z.any().optional(),
    tab: z.string().optional(),
});

function AllTasksPage() {
    useDocumentTitle(`All tasks - Orsane`);
    const queryParams = useRouteTaskQueryParams({ taskListId: undefined, type: "all" });

    return (
        <ContentFrame>
            <TaskQueryParamsProvider value={queryParams}>
                <Suspense fallback={<TaskListRouteSkeleton />}>
                    <SimpleTaskListHeader title="All tasks" icon={Logs} />
                    <TasksTable key="tasklist-all-tasks" disabled={false} />
                </Suspense>

                {/* Right Panel */}
                <SidePanel />
            </TaskQueryParamsProvider>
        </ContentFrame>
    );
}

export const allTasksRoute = createRoute({
    getParentRoute: () => appRoute,
    path: "/all",
    validateSearch: allTasksSearchSchema,
    component: AllTasksPage,
});
